import { GarimposPage } from "@/features/garimpos/garimpos-page";
function GarimposRoute() {
  return <GarimposPage />;
}
export { GarimposRoute as component };